export function getSongCategoryNames(song) {
  if (!song) return []
  if (Array.isArray(song.categories) && song.categories.length > 0) {
    return song.categories.filter((c) => typeof c === 'string' && c.trim()).map((c) => c.trim())
  }
  if (song.category && typeof song.category === 'string' && song.category.trim()) {
    return [song.category.trim()]
  }
  return []
}

export function isSongExcludedForEvent(song, event) {
  if (!song || !event) return false

  const discardedSongIds = Array.isArray(event.discardedSongs)
    ? event.discardedSongs.map((id) => Number(id)).filter((id) => Number.isFinite(id))
    : []
  if (discardedSongIds.includes(Number(song.id))) {
    return true
  }

  const discardedCategories = Array.isArray(event.discardedCategories)
    ? event.discardedCategories.filter((c) => typeof c === 'string' && c.trim()).map((c) => c.trim())
    : []
  if (discardedCategories.length === 0) return false

  const discardedLower = new Set(discardedCategories.map((c) => c.toLowerCase()))
  const songCategories = getSongCategoryNames(song)
  return songCategories.some((cat) => discardedLower.has(cat.toLowerCase()))
}

export function filterSongsForEvent(songs, event) {
  if (!Array.isArray(songs)) return []
  return songs.filter((song) => !isSongExcludedForEvent(song, event))
}
